<template>
  <div id="formView" :class="{ 'form-user-mic': isUserForm }">
    <Topbar @action="fnAction"></Topbar>
    <ClipperImage
      v-if="clipper"
      :image="clipper"
      @getImage="showThumb"
    ></ClipperImage>
    <v-container class="center">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex
                  xs12
                  :md6="flexIsHalf(item)"
                  :md12="flexIsFull(item)"
                  class="item"
                  v-for="(item, key) in params"
                  :key="key"
                >
                  <!--- IMAGE TYPE -->
                  <div class="image" v-if="item.type == 'image'">
                    <img
                      @click="addThumbnail(item.param)"
                      v-if="data[item.param]"
                      :src="data[item.param + '_preview']"
                    />
                    <div
                      @click="addThumbnail(item.param)"
                      v-else
                      class="addthumb"
                    >
                      <div><v-icon x-large>add</v-icon></div>
                      <div class="text">
                        {{ $t("add") + " " + $t(item.label) }}
                      </div>
                    </div>
                    <input
                      type="file"
                      style="display: none"
                      :ref="item.param"
                      accept="image/*"
                      @change="onThumbnailPicked"
                    />
                  </div>
                  <div v-if="item.type == 'file'">
                    <input
                      type="file"
                      id="input_file"
                      :ref="item.param"
                      required
                      @change="onThumbnailPicked"
                    />
                    <label @click="addThumbnail(item.param)"
                      ><img
                        src="/img/add_b.svg"
                        style="height:20px; margin-right:10px;"
                      />{{ $t("add") + " " + $t(item.label) }}</label
                    >
                    <span v-if="data[item.param]">{{
                      data[item.param].name
                    }}</span>
                  </div>

                  <!-- STRING TYPE -->
                  <v-text-field
                    v-if="item.type == 'string'"
                    :label="item.label | i18n"
                    :value="data[item.param] | checkParam"
                    @change="v => (data[item.param] = v)"
                    outline
                    :rules="item.rules"
                    :disabled="item.disabled"
                    :class="{ upper: item.uppercase }"
                  ></v-text-field>

                  <!-- TAGS TYPE -->
                  <v-combobox
                    flat
                    v-if="item.type == 'tags'"
                    :label="item.label | i18n"
                    :value="data[item.param] | checkParam"
                    @change="v => (data[item.param] = v)"
                    outline
                    :rules="item.rules"
                    :disabled="item.disabled"
                    solo
                    multiple
                  >
                    <template v-slot:selection="dataChip">
                      <v-chip
                        :selected="dataChip.selected"
                        close
                        @input="removeChip(item.param, dataChip.item)"
                      >
                        <strong>{{ dataChip.item }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>

                  <!-- INTEGER TYPE -->
                  <v-text-field
                    v-if="item.type == 'integer'"
                    :type="'number'"
                    :label="item.label | i18n"
                    :value="data[item.param] | checkParam"
                    @change="v => (data[item.param] = v)"
                    outline
                    :rules="item.rules"
                    :disabled="item.disabled"
                  ></v-text-field>
                  <!-- SELECT/MULTISELECT TYPE -->
                  <v-select
                    v-if="item.type == 'select'"
                    v-model="data[item.param]"
                    :multiple="item.multiple"
                    :items="getOptions(item.options, item)"
                    :label="item.label | i18n"
                    :disabled="item.disabled"
                    :rules="item.rules"
                  ></v-select>

                  <!-- CEHCK TYPE -->
                  <v-switch
                    v-if="item.type == 'check'"
                    v-model="data[item.param]"
                    :label="item.label | i18n"
                    :disabled="item.disabled"
                  ></v-switch>

                  <!-- AUTOCOMPLETE -->
                  <v-select
                    v-if="
                      item.type == 'autocomplete' &&
                        item.param != 'country_id' &&
                        item.param != 'nacionality'
                    "
                    :no-data-text="$t('errors.write_3_characters')"
                    v-model="data[item.param]"
                    :label="item.label | i18n"
                    :items="cAutoComplete[item.param]"
                    @input.native="loadAutocomplete($event, item)"
                    autocomplete
                    :disabled="item.disabled"
                  ></v-select>
                  <v-select
                    v-if="
                      item.type == 'autocomplete' &&
                        (item.param == 'country_id' ||
                          item.param == 'nacionality')
                    "
                    v-model="data[item.param]"
                    :label="item.label | i18n"
                    :items="countries"
                    @input.native="loadAutocomplete($event, item)"
                    autocomplete
                    :disabled="item.disabled"
                  ></v-select>

                  <!-- TEXTAREA TYPE -->
                  <v-textarea
                    v-if="item.type == 'textarea'"
                    outlined
                    :label="item.label | i18n"
                    :value="data[item.param] | checkParam"
                    @change="v => (data[item.param] = v)"
                    outline
                    :rules="item.rules"
                    :disabled="item.disabled"
                  ></v-textarea>

                  <!-- PASSWORD TYPE -->
                  <template v-if="item.type == 'password'">
                    <v-layout
                      v-if="isUserForm"
                      row
                      wrap
                      class="form-password-fields form-password-fields--grid"
                    >
                      <v-flex xs12 md6>
                        <v-text-field
                          :type="'password'"
                          :label="item.label | i18n"
                          :value="data[item.param] | checkParam"
                          @change="v => (data[item.param] = v)"
                          outline
                          :rules="item.rules"
                          :disabled="item.disabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :type="'password'"
                          :label="(item.label + '_confirmation') | i18n"
                          :value="
                            data[item.param + '_confirmation'] | checkParam
                          "
                          @change="
                            v => (data[item.param + '_confirmation'] = v)
                          "
                          outline
                          :rules="item.rules"
                          :disabled="item.disabled"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <div v-else class="form-password-fields">
                      <v-text-field
                        :type="'password'"
                        :label="item.label | i18n"
                        :value="data[item.param] | checkParam"
                        @change="v => (data[item.param] = v)"
                        outline
                        :rules="item.rules"
                        :disabled="item.disabled"
                      ></v-text-field>
                      <v-text-field
                        :type="'password'"
                        :label="(item.label + '_confirmation') | i18n"
                        :value="
                          data[item.param + '_confirmation'] | checkParam
                        "
                        @change="
                          v => (data[item.param + '_confirmation'] = v)
                        "
                        outline
                        :rules="item.rules"
                        :disabled="item.disabled"
                      ></v-text-field>
                    </div>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/* global moment, sha256 */
import i18n from '@/i18n'
import Topbar from '@/components/ui/Topbar.vue'
import ClipperImage from '@/components/ui/ClipperImage.vue'

export default {
  name: 'FormView',
  components: { Topbar, ClipperImage },
  props: { page: String, action: String },
  data () {
    return {
      data: {},
      valid: true,
      data_loaded: false,
      clipper: false,
      param_select: null,
      autocompletes: {},
      param_autocomplete: false,
      toAutoComplete: null
    }
  },
  computed: {
    isUserForm () {
      const fullPage = this.page.replace('event_', '')
      return fullPage === 'user_add' || fullPage === 'user_edit'
    },

    countries () {
      var oCountries = this.$store.getters.getCountries()
      var aResult = []
      for (var k in oCountries) {
        aResult.push({ text: oCountries[k].name, value: oCountries[k].id })
      }

      return aResult
    },

    params () {
      var fullPage = this.page.replace('event_', '')
      var params =
        fullPage !== 'persons_role_edit'
          ? { ...this.$store.getters['navigation/getCurrentPage'].params }
          : {
            ...this.$store.getters['navigation/getCurrentPage'].types[ this.$route.params.type ].params
          }
      var aParams = []
      for (var k in params) {
        var pr = params[k]
        // console.log( pr );
        if (
          typeof pr.only_event === 'undefined' ||
          !pr.only_event ||
          (pr.only_event && this.$store.getters.isEventSelected)
        ) {
          if(pr.event_type_id == null || typeof pr.event_type_id === 'undefined') {
            aParams.push(pr)
          } else {
            // check if current event type id is equal to param event type id
            const currentEventTypeId = this.$store.getters.isEventSelected
              ? this.$store.getters['events/getCurrentEvent']().type_id
              : null;
            if(currentEventTypeId == pr.event_type_id) {
              aParams.push(pr)
            }
          }
        }
      }
      // console.log( params );
      return aParams
    },

    cAutoComplete: {
      get () {
        return this.autocompletes
      },
      set (value) {
        if (this.param_autocomplete) {
          var oAux = { ...this.autocompletes }
          oAux[this.param_autocomplete] = value
          this.autocompletes = oAux
        }
      }
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'loadDataPage',
    'data.club_id': {
      handler (newVal) {
        if (newVal != null) {
          var club = this.$store.getters['clubs/get_by_id'](newVal)
          if (!this.data.name) {
            this.data.name = club.name
          }
        }
      },
      deep: true
    }
  },
  created () {
    this.loadDataPage()
  },
  methods: {
    flexIsHalf (item) {
      if (!this.isUserForm) {
        return true
      }
      return item.type !== 'password'
    },

    flexIsFull (item) {
      if (!this.isUserForm) {
        return false
      }
      return item.type === 'password'
    },

    async loadDataPage () {
    // Show loading overlay
      this.$overlay.loading()

      // Normalize the page identifiers
      const fullPage = this.page.replace('event_', '')
      const page = fullPage.split('_')[0]

      // Clone route params and append event if selected
      const oParams = { ...this.$route.params }
      if (this.$store.state.event_selected) {
        oParams.event = this.$store.getters['events/getCurrentEvent']().id
      }

      // Preload documentation pages if applicable
      if (page === 'documentation') {
        await this.$store.dispatch(`${page}/loadPages`)
      }

      // Ensure ID param exists
      oParams.id = this.$route.params.id
      const previousPage = this.$store.getters['navigation/getInfoCurrentPage']

      // Load existing data if an ID is present (edit mode)
      if (oParams.id !== undefined) {
        await this.loadExistingData(page, fullPage, oParams)
      } else {
      // Handle pre-filling form data from previous page (e.g., clubs_card → teams_add)
        this.loadNewDataFromPreviousPage(fullPage, previousPage)
        if (fullPage === 'user_add' && typeof this.data.type === 'undefined') {
          this.data = { ...this.data, type: 2 }
        }
      }

      // Hide loading overlay
      this.$overlay.hide()
    },

    async loadExistingData (page, fullPage, oParams) {
      // Dispatch the API call to load the entity by ID
      await this.$store.dispatch(`${page}/load_by_id`, oParams)

      const item = this.$store.getters[`${page}/get_by_id`](oParams.id)

      // Handle standard page types
      if (fullPage !== 'persons_role_edit') {
        this.data = { ...item }
        this.populateParamValues()
      } else {
      // Special handling for editing a person's role
        const currentRole = item.current_roles.find(
          role => Number(role.id) === Number(oParams.role_id)
        )

        if (currentRole) {
          this.data = { ...currentRole }
        }
      }
    },

    loadNewDataFromPreviousPage (fullPage, previousPage) {
      for (const param of this.params) {
      // Auto-fill `club_id` when coming from a club's card
        if (
          ['teams_add', 'teams_edit'].includes(fullPage) &&
        previousPage &&
        /clubs_card/.test(previousPage.name) &&
        param.param === 'club_id'
        ) {
          const club = this.$store.getters['clubs/get_by_id'](previousPage.params.id)
          this.param_autocomplete = param.param
          this.cAutoComplete = [{ text: club.name, value: club.id }]
          this.data[param.param] = club.id
          this.data.name = club.name
        }
      }
    },

    populateParamValues () {
      for (const param of this.params) {
        const value = this.data[param.param]

        // For image fields, create a preview version
        if (param.type === 'image' && value != null) {
          this.data[param.param + '_preview'] = value
        }

        // For autocomplete fields, prefill the select options if not country
        if (
          param.type === 'autocomplete' &&
        value != null &&
        param.param !== 'country_id'
        ) {
          this.param_autocomplete = param.param
          const relation = this.data[param.param.replace('_id', '')]
          this.cAutoComplete = [{
            text: relation ? relation.name : '',
            value: relation ? relation.id : ''
          }]
        }
      }
    },

    getOptions (options, filter) {
      if (typeof options === 'string') {
        var aOptions = []
        let values
        if (typeof filter.params !== 'undefined') {
          values = this.$store.getters[options](filter.params)
        } else {
          values = this.$store.getters[options]()
        }
        aOptions.push({ value: -1, text: i18n.t(filter.label) })
        for (var i in values) {
          var value = values[i]
          const translatedName =
            typeof filter.translate === 'undefined' || filter.translate
              ? i18n.t(value.name)
              : value.name
          aOptions.push({ value: value.id, text: translatedName })
        }
        return aOptions
      } else {
        return options
      }
    },

    loadAutocomplete (event, param) {
      this.param_autocomplete = param.param
      clearTimeout(this.toAutoComplete)
      var self = this
      this.toAutoComplete = setTimeout(function () {
        if (event.target.value.length > 2) {
          self.$store
            .dispatch(param.action, event.target.value)
            .then(function () {
              var aResults = self.$store.getters[param.getter]()
              var aResult = []
              for (var k in aResults) {
                var result = aResults[k]
                aResult.push({ text: result.name, value: result.id })
              }

              self.cAutoComplete = aResult
            })
        }
      }, 200)
    },

    resizeToWebP (dataURL, maxW = 1024, maxH = 1024, quality = 0.8) {
      return new Promise(resolve => {
        const img = new Image()
        img.onload = () => {
          let w = img.width; let h = img.height
          if (w > maxW) { h = h * (maxW / w); w = maxW }
          if (h > maxH) { w = w * (maxH / h); h = maxH }
          const canvas = document.createElement('canvas')
          canvas.width = w
          canvas.height = h
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, w, h)
          resolve(canvas.toDataURL('image/webp', quality))
        }
        img.src = dataURL
      })
    },

    addThumbnail (param) {
      this.param_select = param
      this.$refs[param][0].click()
    },

    onThumbnailPicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].type.includes('image')) {
          if (this.clipper) URL.revokeObjectURL(this.clipper)
          this.clipper = window.URL.createObjectURL(e.target.files[0])
        } else {
          var dataCopy = { ...this.data }
          dataCopy[this.param_select] = e.target.files[0]
          this.data = dataCopy
        }
      }
    },

    async showThumb (image) {
      this.clipper = false
      this.data[`${this.param_select}_preview`] = image
      if (!image) return

      const webpDataURL = await this.resizeToWebP(image, 250, 250, 0.8)

      const [header] = webpDataURL.split(',')
      const mimeMatch = header.match(/:(.*?);/)
      const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream'
      const fileExtension = mimeType.split('/')[1] || 'bin' // fallback just in case

      const file = this.dataURLtoFile(
        webpDataURL,
        `${this.param_select}_${moment().valueOf()}.${fileExtension}`
      )
      this.data[this.param_select] = file
    },

    dataURLtoFile (dataURL, filename) {
      const [header, base64] = dataURL.split(',')
      const mimeMatch = header.match(/:(.*?);/)
      const mime = mimeMatch ? mimeMatch[1] : ''

      const binary = atob(base64)
      const length = binary.length
      const u8arr = new Uint8Array(length)
      for (let i = 0; i < length; i++) {
        u8arr[i] = binary.charCodeAt(i)
      }

      return new File([u8arr], filename, { type: mime })
    },

    fnAction (emit) {
      if (typeof emit.action === 'undefined' || emit.action == null) return
      switch (emit.action) {
        case 'save':
          this.fnSave()
          break
      }
    },

    async fnSave () {
      // Validate form
      if (!this.$refs.form.validate()) {
        this.$popup.alert({
          message: i18n.t('exists_error_on_form'),
          btnSuccess: i18n.t('accept')
        })
        return false
      }

      // Derive page keys
      const fullPage = this.page.replace('event_', '')
      const page = fullPage.split('_')[0]

      // Ensure file present for documentation_add
      if (fullPage === 'documentation_add' && this.data.file == null) {
        this.$popup.alert({
          message: i18n.t('exists_error_on_form_file'),
          btnSuccess: i18n.t('accept')
        })
        return false
      }

      // Hash and compare passwords for user_add / user_edit
      if (fullPage === 'user_edit') {
        const pwd = this.data.password
        if (pwd == null || String(pwd).trim() === '') {
          delete this.data.password
          delete this.data.password_confirmation
        }
      }
      if (
        (fullPage === 'user_add' || fullPage === 'user_edit') &&
        this.data.password != null &&
        String(this.data.password).trim() !== ''
      ) {
        const hashedPwd = sha256(this.data.password)
        const hashedConfirm = sha256(this.data.password_confirmation)
        this.data.password = hashedPwd
        this.data.password_confirmation = hashedConfirm

        if (hashedPwd !== hashedConfirm) {
          this.$popup.alert({
            message: i18n.t('passwords_dont_match'),
            btnSuccess: i18n.t('accept')
          })
          return false
        }
      }

      // Determine current event
      const event = this.$store.getters.isEventSelected
        ? this.$store.getters['events/getCurrentEvent']()
        : false

      // Show overlay
      this.$overlay.loading()

      // Dispatch upload action
      if (fullPage !== 'persons_role_edit') {
        this.$store
          .dispatch(`${page}/upload`, { data: this.data, params: this.params, event })
          .then(idEntity => this.handleSuccessRedirect(page, fullPage, idEntity, event))
      } else {
        const { id, role_id: roleId } = this.$route.params
        this.$store
          .dispatch(`${page}/upload_role`, { data: this.data, params: this.params, id, role_id: roleId })
          .then(() => {
            this.handleSuccessRedirect(page, fullPage, id, event)
            this.$destroy()
          })
      }
    },

    handleSuccessRedirect (page, fullPage, entityId, event) {
      const basePage = event ? `event_${page}` : page
      let routeName
      let routeParams = {}

      if (['documentation_add', 'documentation_edit'].includes(fullPage)) {
        routeName = basePage
      } else {
        routeName = `${basePage}_card`
        routeParams = {
          id: entityId,
          event: event
            ? this.$root.formatEventUrl(event.name, event.edition).replace('/event/', '')
            : null
        }
      }

      this.$router.push({ name: routeName, params: routeParams })
    },

    removeChip (itemParam, item) {
      var dataCopy = { ...this.data }
      dataCopy[itemParam].splice(dataCopy[itemParam].indexOf(item), 1)
      dataCopy[itemParam] = [...dataCopy[itemParam]]
      this.data = dataCopy
    }
  },
  filters: {
    checkParam (value) {
      return value != null ? value : ''
    },

    formatType (value) {
      switch (value) {
        case null:
          return ''
        case 1:
          return 'Administrador Backoffice'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formView {
  width: 100%;
  display: inline-block;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 0px;
        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .image img {
          object-fit: cover;
          display: block;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        label {
          text-transform: capitalize;
        }
        .v-input__prepend-inner {
          margin-top: 25px;
        }
      }

      .v-menu__content {
        position: fixed !important;
      }
      .v-select {
        label {
          text-transform: capitalize;
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }
  }
}
#input_file {
  height: 0;
  overflow: hidden;
  width: 0;
}

#input_file + label {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: black;
  border: 1px dotted black;
  display: inline-block;
  transition: all 0.5s;
  cursor: pointer;
  padding: 15px 40px !important;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}

/* Formulario usuarios MIC (gestores): rejilla 2 columnas en md+, contraseñas en fila completa */
#formView.form-user-mic {
  .container.center {
    max-width: 960px;
    width: 100%;
  }

  .section-container {
    padding: 24px 28px;
  }

  .section-container .layout > .flex.item {
    padding: 0 8px 16px;
  }

  .form-password-fields {
    width: 100%;
  }

  .form-password-fields--grid {
    margin: 0 -8px;
    width: calc(100% + 16px);
  }

  .form-password-fields--grid > .flex {
    padding: 0 8px;
  }

  .form-password-fields:not(.form-password-fields--grid)
    .v-text-field:first-child {
    margin-bottom: 8px;
  }
}
</style>
